package com.kinoshazam.uiKit.config

import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.mutableStateOf
import utils.FormFactor

internal val LocalFormFactor =
    compositionLocalOf<FormFactor> { error("FormFactor not provided!!!") }

val uiKitFormFactor = mutableStateOf<FormFactor>(FormFactor.Compact)

